import React from 'react';
import styled from 'styled-components';
// import { Thermometer } from './Thermometer';
import { toPounds } from './../../services/Formats';

/*
 > button.im {
   min-height: 300px;
   background: url(images/temperature-gray.png) no-repeat 0px 0px;
   background-size: 100%;
 }
 > button.im.active { background-image: url(images/temperature-lightblue.png); }
 > button.im:hover { background-image: url(images/temperature-lightblue.png); }
*/

const LevelsTopDiv = styled.div`
  position: relative;
  padding-bottom: 130px;
  @media(max-width:480px) { padding-bottom: 180px; }
`;

const Columns2 = styled.div`
  display: flex;
  align-items: flex-end;
  margin-bottom: 20px;
  .pct { color: #62ad4e; text-align: center; font-weight: bold; font-family: 'Nunito Sans',arial; font-size: 22px;  }
  > .person { width: 60%; }
`;

const LevelsDiv = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-around;

  .title {
     height: 60px;
     width: 100%;
     background: transparent;
     text-align: center;
     color: #000;
     font-size: 16px;
     font-weight: bold;
     font-family: 'Nunito Sans',arial;
  }
  .amount {
    padding-top: 5px;
    font-size: 16px;
    color: #209546;
  }
  @media(max-width:640px) { .title { font-size: 12px; font-weight: normal; } }
  @media(max-width:480px) { .title { font-size: 10px; font-weight: normal; } }

  .person {
    img { width: 60px; }
    @media(max-width:640px) { img { width: 45px; } }
    @media(max-width:480px) { img { width: 35px; } }
  }

  > button {
    width: 25%;
    border: none;
    cursor: pointer;
    outline: none !important;
    background: transparent;
  }

  .hint {
    display: none;
    position: absolute;
    top: 250px;
    left: 5%;
    width: 80%;
    background: #f3f7ea;
    font-family: 'Nunito Sans',arial;
    font-size: 16px;
    color: #000;
    padding: 30px;

    @media(max-width:640px) { top: 220px; }
    @media(max-width:480px) { top: 180px; }

  }
  > button.active .hint { display: block; }
  .coins {
    width: 46px;
    background: url(images/coins-bk.png) 0px 0px no-repeat;
    background-size: 100%;
    position: relative;

    img {
      width: 46px;
      position: absolute;
      left: 0px;
      bottom: 0px;
    }
    @media(max-width:640px) { width: 35px; img { width: 35px; }}
    @media(max-width:680px) { width: 25px; img { width: 25px; }}
  }
  .pct {
    @media(max-width:640px) { font-size: 16px }
    @media(max-width:480px) { font-size: 14px }
  }
`;

const T = ['Healthy', 'Mild', 'Moderate', 'Severe'];
const I = ['images/level-v2-0.png', 'images/level-v2-1.png', 'images/level-v2-2.png', 'images/level-v2-3.png'];
const D = [
  'Would have a Body Mass Index (BMI) within the ‘healthy’ range and would answer ‘No’ to all of our health questions.',
  'Possibly overweight. Could be a smoker. Might also be taking tablets to control an ongoing medical condition such as hypertension (high blood pressure).',
  'Possibly overweight/obese on the BMI scale. May have life-shortening conditions that can have knock-on, long-term effects to health such as diabetes (type 1 or type 2). May have a combination of conditions (e.g. overweight and diabetic).',
  'Possibly obese/morbidly obese on BMI scale. Could have more serious, life-threatening conditions such as cancer, stroke, Parkinson’s etc. Will have ticked ‘Yes’ to a number of questions on our health questionnaire.'
];

const GrayArrowDiv = styled.div`
  position: absolute;
  top: 240px;
  @media(max-width:640px) { top: 210px; }
  @media(max-width:480px) { top: 170px; }

`;
const GrayArrow = ({ color, index }) => {
  const positions = { 0: '11%', 1: '36%', 2: '61%', 3: '86%' };
  if (!positions[index]) return false;

  return (
    <GrayArrowDiv style={{ left: positions[index] }}>
      <svg height="12" width="31" viewBox='0 0 31 12'>
		    <polygon style={{ fill: color }} points="0,11 15,0 29,11" />
      </svg>
    </GrayArrowDiv>
  );
}

const maxPctValue = 54.5 * 1.3;
const maxCoinsHeight = 130;
export const LevelsOfEnhancement = ({ input, output, onChangePlan }) => {
  return (
    <LevelsTopDiv>
      <LevelsDiv key={1}>
        {T.map((t, index) => (
          <button
            key={t} className={`im ${(t === input.ltvPlan) ? 'active' : ''}`}
            onClick={() => (onChangePlan(t))}
          >
            <div>
              <Columns2>
                <div className='person'>
                  <img src={I[index]} alt={input.ltvPlan} />
                </div>
                <div>
                  <div className="pct">{output.ltv.pct[t]}%</div>
                  <div className="coins" style={{ height: output.ltv.pct[t] * maxCoinsHeight / maxPctValue }} >
                    <img src="images/coins-under-bk.png" alt="" />
                  </div>
                </div>
              </Columns2>
            </div>
            <div className={`title ${(t === input.ltvPlan) ? 'active' : ''}`}>
              {t}
              <br />
              <div className="amount">
                {toPounds(output.ltv[t])}
              </div>
            </div>

            {(t === input.ltvPlan) ? <GrayArrow index={index} color='#f3f7ea' /> : false}
            <div className="hint">
              <strong>{t}:</strong> {D[index]}
            </div>
          </button>
        ))}
      </LevelsDiv>



    </LevelsTopDiv>
  );
};



// WEBPACK FOOTER //
// ./src/components/LtvCalculator/LevelsOfEnhancement.js